import { FilterMode } from "@doitintl/cmp-models";

import { type MetadataOption } from "../../../types";
import { FilterModeOption } from "./types";

export const getPlural = (selected: MetadataOption) => {
  const label = selected.data.label ?? selected.data.field;
  const plural = selected.data.plural ?? label;
  return { plural, label };
};

export const getMode = (rule: FilterModeOption): FilterMode => {
  switch (rule) {
    case FilterModeOption.IS:
    case FilterModeOption.IS_NOT:
      return FilterMode.IS;
    case FilterModeOption.MATCHES_REGEX:
    case FilterModeOption.DOES_NOT_MATCHES_REGEX:
      return FilterMode.REGEXP;
    case FilterModeOption.CONTAINS:
    case FilterModeOption.DOES_NOT_CONTAIN:
      return FilterMode.CONTAINS;
    case FilterModeOption.STARTS_WITH:
      return FilterMode.STARTS_WITH;
    case FilterModeOption.ENDS_WITH:
      return FilterMode.ENDS_WITH;
    default:
      return FilterMode.IS;
  }
};

export const getModeLabel = (rule, reverse: boolean): FilterModeOption => {
  switch (rule) {
    case "is":
      return reverse ? FilterModeOption.IS_NOT : FilterModeOption.IS;
    case "regexp":
      return reverse ? FilterModeOption.DOES_NOT_MATCHES_REGEX : FilterModeOption.MATCHES_REGEX;
    case "contains":
      return reverse ? FilterModeOption.DOES_NOT_CONTAIN : FilterModeOption.CONTAINS;
    case "starts_with":
      return FilterModeOption.STARTS_WITH;
    case "ends_with":
      return FilterModeOption.ENDS_WITH;
    default:
      return FilterModeOption.IS;
  }
};

export const getFilterModeValues = (mode: FilterModeOption) => ({
  inverse:
    mode === FilterModeOption.IS_NOT ||
    mode === FilterModeOption.DOES_NOT_CONTAIN ||
    mode === FilterModeOption.DOES_NOT_MATCHES_REGEX,
  mode: getMode(mode),
});

export const getInverse = (mode: FilterModeOption) =>
  mode === FilterModeOption.IS_NOT ||
  mode === FilterModeOption.DOES_NOT_CONTAIN ||
  mode === FilterModeOption.DOES_NOT_MATCHES_REGEX;
